import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "logo",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 800 800"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<polyline class=\"cls-1 logo-shape1\" points=\"643.7 257.6 768.8 31.2 768.8 768.8 400 447.4 31.2 768.8 31.2 31.2 156.3 257.6\"></polyline><polyline class=\"cls-1 logo-shape2\" points=\"261.2 447.4 400 698.6 538.8 447.4\"></polyline><circle class=\"cls-2 logo-shape3\" cx=\"400\" cy=\"218.8\" r=\"117.1\"></circle><line class=\"cls-1 logo-line logo-line1\" x1=\"227.2\" y1=\"572.8\" x2=\"572.8\" y2=\"227.2\"></line><line class=\"cls-1 logo-line logo-line2\" x1=\"572.8\" y1=\"572.8\" x2=\"227.2\" y2=\"227.2\"></line>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_7))
}